module.exports = __webpack_public_path__ + "static/media/linkedin.0bc089f1.svg";